import BC from '../init';

export default BC.Methods.testMethod = ($this) => {
    const el = $this;
    console.log('data function', $this);
};
